import { render, staticRenderFns } from "./common-load-box.vue?vue&type=template&id=041d5bfc&lang=pug&"
import script from "./common-load-box.vue?vue&type=script&lang=js&"
export * from "./common-load-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports